module.exports = __webpack_public_path__ + "img/search.82e23912.svg";